<template>
  <div class="container">
    <div class="evaluate_main">
      <!-- 产品评价 -->
      <div class="common_modal" v-if="openProject">
        <div class="common_title common_title_center">{{projectTitle}}</div>
        <div class="ext1_main_img"  v-for="(item,index) in evaluateOutputList" :key="index">
          <div class="ext1_left" v-if="item.evaluateType == 1 && item.number == 1">
            <img class="ext1_main_img_i" src="../../../assets/images/evaluate/bmy_ok.png"/>
            <div class="ext1_main_img_t unlike">不满意</div>
          </div>
          <div class="ext1_right" v-if="item.evaluateType == 1 && item.number == 2">
            <img class="ext1_main_img_i" src="../../../assets/images/evaluate/my_ok.png"/>
            <div class="ext1_main_img_t like">满意</div>
          </div>
        </div>
        <div class="ext3">
          <div class="labelBoxArticle">
            <template v-for="(item,index) in evaluateOutputList">
            <div :key="index" v-if="item.evaluateType === 3 && item.evaluateItemType == 1" class="labelBoxdiv labelBoxActive">{{item.items}}</div>
           </template>
          </div>
        </div>
        <div class="comment_main" v-if="projectComment">
          <img class="comment_main_i" src="../../../assets/images/evaluate/text.png"/>
          <p class="comment_main_t">{{projectComment}}</p>
        </div>
      </div>
      <!-- 服务评价 -->
      <div class="common_modal">
        <div class="common_title common_title_center">服务评价</div>
        <div class="ext2_main_list">
          <div v-for="(item,index) in starArr" :key="index">
            <img class="star_icon" v-if="serviceEvaluateStar > index" src="../../../assets/images/evaluate/star_ok.png"/>
            <img class="star_icon"  v-else src="../../../assets/images/evaluate/star_default.png"/>
          </div>
        </div>
        <div class="fiveStari">{{serviceEvaluateStar | evaluateStatus}}</div>
        <div class="ext3">
          <div class="labelBoxArticle">
            <template v-for="(item,index) in evaluateOutputList">
            <div class="labelBoxdiv labelBoxActive" bindtap="changeLabel" :key="index" v-if="item.evaluateType === 3 && item.evaluateItemType == 2">{{item.items}}</div>
            </template>
          </div>
        </div>
        <div class="comment_main" v-if="comment">
          <img class="comment_main_i" src="../../../assets/images/evaluate/text.png"/>
          <p class="comment_main_t">{{comment}}</p>
        </div>
      </div>
  </div>
  </div>
</template>

<script>

import { getEvaluateDetail} from '../../../utils/api'
export default {
  name:"viewEvaluate",
  data(){
    return{
      beEvaluatedId:'',
      isclick:false,
      starArr:[1,2,3,4,5],
      openProject:"",
      projectComment:'',//产品评价
      serviceEvaluateStar:0,
      projectTitle:'',//标题
      comment:'',//评价内容
      evaluateOutputList:[]
    }
  },
  filters:{
    evaluateStatus(status){
      switch (status) {
        case 1:
       return '非常差'
     case 2:
       return '差'
     case 3:
       return '一般'
     case 4:
       return '满意'
     case 5:
       return '非常满意'
     }
   }
  },
  created(){
      this.beEvaluatedId = this.$route.query.id
      this.getEvaluateDetail();
  },
  methods: {
    getEvaluateDetail() {
      getEvaluateDetail({
        "beEvaluatedId": this.beEvaluatedId
      }).then(res => {
        console.log(res)
        let evaluate = res.body.evaluate;
        evaluate.evaluateOutputList.forEach(item=>{
          if(item.evaluateType == 2){
              this.serviceEvaluateStar = item.number
          }
        })
          this.projectTitle = evaluate.projectTitle || '';
          this.comment = evaluate.comment || '';
          this.projectComment = evaluate.projectComment || '';
          this.evaluateOutputList = evaluate.evaluateOutputList;
          this.openProject = evaluate.openProject || '';
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.common_modal{
  margin:20px;
  background:#fff;
  border-radius:16px;
  padding-bottom:28px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
}
.evaluate_main{
  margin-bottom:110px;
}
.ext1_main,.ext2_main,.ext4_main{
  padding:40px;
}
.common_title{
  font-size:28px;
  color:#333;
  line-height:40px;
  height:40px;
  display:block;
  width:100%;
  margin:40px 0;
}
.common_title_center{
  text-align:center;
}
.ext1_main_img{
  display:flex;
  flex-direction:row;
  justify-content:center;

}
.ext1_main_img_i{
  display:block;
  width:80px;
  height:80px;
  margin-bottom:20px;
}
.ext1_main_img_t{
  color:#999;
  font-size:24px;
  line-height:34px;
}
.ext1_main_img .unlike{
  color:#FF7800;
}
.ext1_main_img .like{
  color:#FF7800;
}
.ext1_left,.ext1_right{
  width:240px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
}
/* ext2_main */
.ext2_main_list{
  display:flex;
  flex-direction:row;
  margin-bottom:28px;
}
.fiveStarLabel{
  font-size:28px;
  line-height:44px;
  color:#333;
  display:block;
  margin-right:20px;
  min-width:150px;
}
.star_icon{
  width:52px;
  height:52px;
  margin-right:24px;
  display:block;
}
.fiveStari{
  font-size:24px;
  color:#FF7800;
  line-height:44px;
}
/* ext3 */
.ext3{
  margin-top: 20px;
  margin-bottom: 26px;
}
.labelBoxArticle{
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  justify-content:center;
}
.labelBoxText{
  padding:0 26px;
  height:56px;
  border-radius:28px;
  text-align:center;
  line-height:56px;
  display:block;
  color:#999;
  font-size:24px;
  margin-right:14px;
  margin-bottom:14px;
}
.labelBoxActive{
  height:48px;
  border-radius:4px;
  line-height: 48px;
  text-align: center;
  padding:0px 12px;
  background:rgba(248,248,248,1);
  font-size:24px;
  font-family:PingFangSC;
  font-weight:400;
  color:rgba(102,102,102,1);
  margin: 0 10px 14px;
}
/* ext4 */
.textPlace{
  font-size:28px;
  color:#c9c9c9;
  line-height:40px;
}
.textarea{
  .border();
  border-radius:8px;
  height:180px;
  width:614px;
  padding:20px;
  color:#333;
  font-size:28px;
  line-height:40px;
  background:#eaeaea;
}
.comment_main{
  padding:0 40px;
  width:100%;
  box-sizing:border-box;
  display:flex;
  flex-direction:row;
  justify-content:flex-start;
}
.comment_main_i{
  display:block;
  width:24px;
  height:22px;
  margin-right:20px;
}
.comment_main_t{
  flex: 1;
  font-size:28px;
  line-height:36px;
  flex-wrap: wrap;
  color:#999;
  text-align: left;
  // padding-right: 10px;
  box-sizing: border-box;
  word-wrap:break-word;
  word-break:break-all;
  overflow: hidden;

}
</style>
